import { BrandGlyph } from "@aigntx/ui";

/** The app-icon mark: a rounded gradient tile with a white brand glyph. */
export function BrandMark({ icon, size = 30 }: { icon?: string; size?: number }) {
  return (
    <span className="brand__mark" style={{ inlineSize: size, blockSize: size }}>
      <BrandGlyph id={icon} size={Math.round(size * 0.54)} />
    </span>
  );
}
